import React from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { Form } from "antd";
import { withActions, isBusy, getError } from "actionware";

import { approval } from "./applicationApprovalActions";
import BulkApplication from "./bulkApplicationDetail";
@withActions({ approval })
class ApplicationDetail extends React.Component {
  constructor() {
    super();
    this.handleApproval = this.handleApproval.bind(this);
  }

  handleApproval(details, password) {
    const { approval, modalType } = this.props;
    const applications = details.map((detail) => ({
      application_id: detail.application_id,
    }));
    const payload = {
      applications: applications,
      action: modalType,
    };
    approval(payload);
  }
  render() {
    const { detail, translate, form, modalType, onCancel, loading } =
      this.props;
    let modal;
    modal = BulkApplication(
      detail,
      translate,
      form,
      onCancel,
      this.handleApproval,
      modalType,
      loading
    );
    return <div className={`application-modal`}>{modal}</div>;
  }
}

const ApplicationDetailFormed = Form.create({})(ApplicationDetail);
const mapStateToProps = ({
  localize,
  applicationApproval: { showingApplicationApprovalModal, applications },
  session: { user },
}) => ({
  translate: getTranslate(localize),
  showingApplicationApprovalModal,
  user,
  applications,
  loading: isBusy(approval),
  error: getError(approval),
});

export default connect(mapStateToProps)(ApplicationDetailFormed);
